import { Component, Input, OnInit } from '@angular/core';
import { PfandrechtMasterDetailEntryMeta } from '../../../../core/gb-api';
import { TranslatePipe } from '@ngx-translate/core';
import { HistoryDirective } from '../../../../shared/directives/history.directive';
import { KompaktPersongbComponent } from '../../../../shared/kompaktdarstellung/persongb/kompakt-persongb.component';
import { KompaktTimepointComponent } from '../../../../shared/kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { RechtsgrundComponent } from '../../../../shared/kompaktdarstellung/rechtsgrund/rechtsgrund.component';
import { NgTemplateOutlet } from '@angular/common';
import { TranslateNamePipe } from '../../../../shared/pipes/simple/translate-name.pipe';

@Component({
  selector: 'cap-pfandrecht-schuldner',
  templateUrl: './pfandrecht-schuldner.component.html',
  styleUrls: ['./pfandrecht-schuldner.component.scss'],
  imports: [
    TranslatePipe,
    HistoryDirective,
    KompaktPersongbComponent,
    KompaktTimepointComponent,
    RechtsgrundComponent,
    NgTemplateOutlet,
    TranslateNamePipe
  ]
})
export class PfandrechtSchuldnerComponent implements OnInit {
  @Input()
  recht: PfandrechtMasterDetailEntryMeta;

  constructor() {}

  ngOnInit() {}
}
